import { jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';
import { BoxQuestionnaireStatus } from '../../../shared/enums';
import { PublicBoxQuestionnaireFileResponse } from './public-box-questionnaire-file.response';
import { PublicBoxQuestionnaireContextOperationsResponse } from './public-box-questionnaire-context-operations.response';
import { PublicBoxQuestionnaireOrderResponse } from './public-box-questionnaire-order.response';

@jsonObject
export class PublicBoxQuestionnaireCollectionItemResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(Boolean)
  public readonly isShown!: boolean;

  @jsonMember(String)
  public readonly status!: BoxQuestionnaireStatus;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(Date)
  public readonly endDate!: Date;

  @jsonMember(PublicBoxQuestionnaireFileResponse)
  public readonly logo!: PublicBoxQuestionnaireFileResponse;

  @jsonMember(PublicBoxQuestionnaireOrderResponse)
  public readonly order!: PublicBoxQuestionnaireOrderResponse;

  @jsonMember(PublicBoxQuestionnaireContextOperationsResponse)
  public readonly contextOperations!: PublicBoxQuestionnaireContextOperationsResponse;
}
